import React, { useEffect, useRef, useState } from 'react'
import BlockTitle from '../common/BlockTitle'
// import classnames from 'classnames'
import { calculateStickyLimit, Sticky, Range } from '../common/Stiky'
import ScrollElememt from '../../../components/ScrollElement'
import useRandomId from '../../../hooks/useRandomId'
import './style.scss'

const parts = [
  {
    title: 'Q3',
    color: '#D6FF80',
    description:
      'Research Setup, technical code rule release, filter rule, rule database',
  },
  {
    title: 'Q4',
    color: '#B5FD85',
    description:
      'TestNet, self-security audit, security system, Relay Instance',
  },
  {
    title: 'Q1',
    color: '#89FC8B',
    description:
      'MainNet, cross-industry cooperation, malicious bot tracking feature launch',
  },
  {
    title: 'Q2',
    color: '#55FA91',
    description: 'Relay Network launch',
  },
]

type ConfidenceLimits = [Range, Range]

const Roadmap: React.FC = () => {
  const $containerRef = useRef<HTMLDivElement>(null)
  const [$container, set$container] = useState<HTMLDivElement | null>(null)
  const [$title, set$title] = useState<HTMLDivElement | null>(null)
  // const stickies = useMemo(() => {
  //   const ret: HTMLElement[] = []
  //   if ($title) {
  //     ret.push($title)
  //   }
  //   return ret
  // }, [$title])
  // const limits = useMemo<HighlightsLimits | null>
  const [limits, setLimits] = useState<ConfidenceLimits | null>(null)
  const titleOnceKey = useRandomId()
  const mapOnceKey = useRandomId()

  useEffect(() => {
    if (!$container || !$title) return
    if (limits) return
    setLimits(calculateStickyLimit($container, [$title]) as ConfidenceLimits)
  }, [limits, $container, $title])

  useEffect(() => {
    set$container($containerRef.current)
  }, [])

  return (
    <div id="roadmap" ref={$containerRef}>
      <Sticky range={limits?.[0]} el={$title} zIndex={101}>
        <BlockTitle
          title="RoadMap"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
        />
      </Sticky>
      <div className="content">
        <ScrollElememt
          className="map"
          activeClassName="active"
          onceKey={mapOnceKey}
        >
          {parts.map((part, i) => (
            <div className="point" key={i}>
              <div className="title" style={{ color: part.color }}>
                {part.title}
              </div>
              <div className="bar">
                <div style={{ backgroundColor: part.color }} />
              </div>
              <div className="description">{part.description}</div>
            </div>
          ))}
        </ScrollElememt>
      </div>
    </div>
  )
}

export default Roadmap
